<template>
  <div>

    <div class="row">
      <div class="col">
        <button class="btn btn-warning btn-block" @click="onTaminClicked(row.product.id)">تامین</button>
        <!--<router-link :to="'/production-management/supply/' + row.product.id" class="btn btn-info btn-block">تامین</router-link>-->
      </div>
    </div>
  </div>
</template>

<script>

  import VsSelect from "../_framework/VsSelect";
  import BaseService from "../_framework/api/BaseService.js";
  import EventBus from "../bus.js";
  import axios from "axios";

  export default {
    name: 'open-supply',
    props: ['row'],
    components: {
      VsSelect
    },
    data() {
      return {
        names: [],
        selectedProductPattern: null,
        model: null,
        showModal: true,
        patterns: null,
        createPatternModel: {
          patternId: 0,
          count: 0,
          orderDetailId: 0
        },
        worksCount: 0

      }
    },
    mounted() {
      this.refreshTable();
      setTimeout(() => {
        // this.getOrderList();
        // this.calculateWorksCount();
      }, 500)

    },
    methods: {
      refreshTable() {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
        // this.$refs.table.onFetchEntityList();
      },
      onTaminClicked(id) {
        this.$router.push({
          path: "/supply/" + id
        });
      },

      /*  calculateWorksCount() {
            // console.log(this.row.worksCount);
            this.createPatternModel.count = this.row.unitVal;
            this.worksCount = this.row.worksCount;

            if (this.row.worksCount) {
                // console.log(this.row.worksCount);
                this.createPatternModel.count -= this.worksCount;
            }
            if (this.createPatternModel.count <= 0) {
                this.createPatternModel.count = 0 ;
            }
        },
        /!* onMaterialModalOk() {
           this.$emit(
             "dataChanged",
             this.headerKey,
             this.vsTableFeed.map(m => {
               return m;
             })
           );
           if (this.mode !== "create") {
             EventBus.$emit("materialChanged");
           }
         },*!/
        getPatterns(id) {

            new BaseService('Patterns', `/GetProductPatterns/${id}`).getList().then((response) => {
                this.names = response.data;

                if (this.names.length <= 0 ) {
                    this.showModal = false;
                    this.$noty.warning("این محصول الگویی برای تولید ندارد")
                    // console.log(this.showModal)
                }
                this.$refs['productOrder'].show()
            }).catch((error) => {
                console.log(error)
            }).then(() => {

            });
        },
        getOrderList() {
            new BaseService('ProductionManagements', '/GetManageOrder').getList().then((response) => {
                this.refreshTable()
            }).catch((error) => {
                console.log(error)
            });
        },
        sendOrderToProduce() {
            let model = {
                patternId: this.$refs.selectPattern.selectedValue.id,
                count: parseInt(this.createPatternModel.count),
                orderDetailId: this.row.id
            };
            new BaseService('Works', '/CreateWorkFromOrder').create(model).then((response) => {
                // console.log("ok button clicked");
                this.$noty.success("سفارش به خط تولید ارسال شد");
                this.$refs.selectPattern.$data.selectedValue = null;
                this.worksCount += parseInt(this.createPatternModel.count);

                // this.getOrderList();
                this.refreshTable();
                this.calculateWorksCount();
            }).catch((error) => {
                // TODO: change error message and put if condition for it
                // this.$noty.error("عدد کار برای این سفارش ثبت شده و دیگر نمیتوانید کار جدید ثبت کنید")
            });

        }*/
    }
  }

</script>

<style scoped lang="scss">
  .black {
    color: black;
  }
</style>
